export const getPasswordFormErrorLabel = (code: string | null) => {
    if (!code) return '';

    switch (code) {
        case 'password_not_match':
            return 'Неверный пароль — попробуйте ещё раз';
        default:
            return 'Неверный пароль — попробуйте ещё раз';
    }
};
